// src/components/RegistrationCBG.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { ACTIVE_API_BASE_URL } from "../config/apiConfig"
import apiClient from '../api/axiosClient';
import { ChevronLeft, ChevronRight, Save } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/FormProduction.css';
import SidebarGuideline from "./SidebarGuideline"
import TextField from "@mui/material/TextField";
import {downloadFile} from '../common'

// Constants for max lengths
const FIELD_MAX_LENGTH = 100;
const COMPANY_PROFILE_MAX_LENGTH = 300;
const COMMENT_MAX_LENGTH = 200;
const PHONE_MAX_LENGTH = 10;

// Validation regex
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^\d{10}$/;

const RegistrationCBG = () => {
  const location = useLocation();
  const [activeItem, setActiveItem] = useState(null);
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState();
  const awardTitle = location.state?.awardTitle || 'CBG Company of the Year';
  const [formId, setFormId] = useState("Unknown");
  const [PkId, setPkId] = useState(0);

  // Form state initialization
  const [formData, setFormData] = useState({
    Organisationname: '',
    category: 'CBG Company of the Year',
    mailingAddress: '',
    authorityName: '',
    authorityTitle: '',
    authorityPhone: '',
    authorityLandline: "",
    authorityEmail: '',
    applicant_name: "",
    applicant_phone: "",
    applicant_email: "",
    contact_name: '',
    contact_phone: '',
    contact_email: '',
    companyProfile: '',
    approvingAuthoritySignature: null,
    declaration: false,
    comment: '',
    retailOutlets2024: ['', ''],
    install2024: ['', ''],
    actual2024: ['', ''],
    safety2024: ['', ''],
    accident_rate2024: ['', ''],
    totalhourworked2024: ['', ''],
    injury2024: ['', ''],
    incident_rate2024: ['', ''],
    lubricantsSales2024: ['', ''],
    patent2024: ['', ''],
    national2024: ['', ''],
    international2024: ['', ''],
    commercial2024: ['', ''],
    attachments1: { description: '', file: null },
    attachments2: { description: '', file: null },
    attachments3: { description: '', file: null },
    attachments4: { description: '', file: null },
  });

  


  useEffect(() => {
    try {
      const stored = sessionStorage.getItem("user_info");
      console.log('called item', stored)
      if (stored) {
        const user = JSON.parse(stored);
        setUserInfo(JSON.parse(stored));
        setFormId(`RegistrationCBG_${user.id}`);
        setFormData((prev) => ({
          ...prev,
          userid: user.id || "",
          firstname: user.first_name || "",
          lastname: user.last_name || "",
          company_name: user.organisation_name || "",
          Organisationname: user.organisation_name || "", // prefill organisation_name field
          // Fill applicant_* only (we DON'T prefill contact_* here)
          applicant_name: user.applicant_name || "",
          applicant_phone: user.applicant_phone || "",
          applicant_email: user.email || "",
        }));
      }
    } catch (err) {
      console.warn("Failed to parse user_info from localStorage:", err);
    }

  }, []);


  // This use Effect Prefill user Data using api;
  useEffect(() => {
    console.log("useEffect all prefillFormDAta")
    if (userInfo && formId) {
      prefillFormData();
    } else {
      console.warn(
        `userInfo OR formId is invalid; Kindly check the method. and data`
      );
    }
  }, [userInfo, formId]);

  const isSubmited = () => formData.form_mode === 'submit';

  function prefillFormData() {
  if (!userInfo || !formId) {
    console.warn("prefillFormData: missing userInfo or formId");
    return;
  }

  const url = `/registration-cbg/?user_id=${userInfo.id}&form_id=${formId}`;
  console.log(url)
  apiClient
    .get(url)
    .then((res) => {
      console.log('CBG response ', res)
      // Expect exactly one existing record to prefill
      if (!Array.isArray(res.data) || res.data.length !== 1) {
        console.log("No prefill data found (or multiple):", res.data);
        return;
      }

      const _ResData = res.data[0];
      setPkId(_ResData.id || 0);

      // helpers
      const toCamelLocal = (s = "") =>
        String(s)
          .replace(/[-_ ]+([a-zA-Z0-9])/g, (_, c) => (c ? c.toUpperCase() : ""))
          .replace(/^[A-Z]/, (c) => c.toLowerCase());

      // attempt to read a value using several key name variants
      const readFirst = (...keys) => {
        for (const k of keys) {
          if (Object.prototype.hasOwnProperty.call(_ResData, k) && _ResData[k] !== null && _ResData[k] !== undefined) {
            return _ResData[k];
          }
        }
        return undefined;
      };

      // Build the base newFields object using server response (map server names -> your state names)
      const newFields = {
        Organisationname:
          readFirst("organisation_name", "organisationName", "company_name") ?? "",
        category: readFirst("category") ?? "CBG Company of the Year",
        mailingAddress: readFirst("mailing_address", "mailingAddress") ?? "",
        authorityName: readFirst("authority_name") ?? "",
        authorityTitle: readFirst("authority_title") ?? "",
        authorityPhone: readFirst("authority_phone") ?? "",
        authorityLandline: readFirst("authorityLandline", "authority_landline") ?? "",
        authorityEmail: readFirst("authority_email") ?? "",
        applicant_name: readFirst("applicant_name", "contact_name") ?? "",
        applicant_phone: readFirst("applicant_phone", "contact_phone") ?? "",
        applicant_email: readFirst("applicant_email", "contact_email", "email") ?? "",
        contact_name: readFirst("contact_name") ?? "",
        contact_phone: readFirst("contact_phone") ?? "",
        contact_email: readFirst("contact_email") ?? "",
        companyProfile: readFirst("company_profile") ?? "",
        comment: readFirst("comment") ?? "",
        // convert string "true"/"false" to boolean as your state uses boolean
        declaration:
          readFirst("declaration") === true || readFirst("declaration") === "true" || readFirst("declaration") === 1,
        form_mode: readFirst("form_mode") ?? readFirst("formMode") ?? "draft",
        // keep approvingAuthoritySignature FILE null (file upload), but keep a preview url
        approvingAuthoritySignature: null,
        approvingAuthoritySignatureUrl: readFirst("approving_authority_file", "approving_authority_file_url", "approving_authority_file_url") ?? null,
      };

      // ---- Prefill metric arrays (two values: 2024, 2023) ----
      // This mirrors the base names used in your handleSubmit.
      const metrics = [
        ["retail_outlets", "retailOutlets2024"],
        ["install_capacity", "install2024"],
        ["actual_prod", "actual2024"],
        ["safety_index", "safety2024"],
        ["accident_rate", "accident_rate2024"],
        ["totalhourworked", "totalhourworked2024"], 
        ["lost_injury_rate", "injury2024"],
        ["incident_rate", "incident_rate2024"],
        ["lubricants_sales", "lubricantsSales2024"],
        ["patents_filed", "patent2024"],
        ["patents_national", "national2024"],
        ["patents_international", "international2024"],
        ["patents_commercial", "commercial2024"],
      ];

      const getYearValue = (base, year) => {
        // candidate names to check in _ResData for the given year
        const cand = [
          `${base}_${year}`, // snake_case_year
          `${base}${year}`, // base + year without underscore
          `${toCamelLocal(base)}${year}`, // camelCase + year
          `${toCamelLocal(base)}_${year}`, // camelCase + _year
        ];
        // if base already includes a year suffix (e.g. base endsWith '2024'), include it directly
        if (/\b202[34]$/.test(base)) {
          cand.unshift(base);
        }
        // try candidates and return first non-null
        const found = readFirst(...cand);
        return found === undefined || found === null ? "" : String(found);
      };

      metrics.forEach(([base, stateKey]) => {
        const v2024 = getYearValue(base, "2024");
        const v2023 = getYearValue(base, "2023");
        newFields[stateKey] = [v2024, v2023];
      });

      // ---- Attachments 1..4 (keep file:null and provide url/description) ----
      for (let n = 1; n <= 4; n++) {
        const desc = readFirst(`attachments${n}_description`, `attachments${n}_desc`, `attachments${n}Description`) ?? "";
        const urlVal = readFirst(`attachments${n}`, `attachments${n}_url`, `attachments${n}Url`) ?? null;
        newFields[`attachments${n}`] = {
          description: desc,
          file: null,
          url: urlVal,
        };
      }

      // immutably apply state update so controlled inputs update properly
      setFormData((prev) => ({ ...prev, ...newFields }));

      console.log("prefillFormData: applied values, pkId:", _ResData.id);
    })
    .catch((err) => {
      console.error("prefillFormData error:", err);
    });
}

  

  // UI State
  const [currentStep, setCurrentStep] = useState(1);
  const [copyApplicantData, setCopyApplicantData] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');


  const headerNums = ["4", "5"];

  // Validation helpers
  const validateEmail = (email) => emailRegex.test(email);
  const validatePhone = (phone) => phoneRegex.test(phone);

  // Clear error on field
  const clearFieldError = useCallback((field) => {
    setFieldErrors((prev) => {
      if (prev[field]) {
        const { [field]: omitted, ...rest } = prev;
        return rest;
      }
      return prev;
    });
  }, []);

  // Handle changes for inputs/textareas/selects
  const handleChange = (name, value, index = null) => {
    if ([1, 2, 4].includes(currentStep)) {
      let applicableMaxLength = FIELD_MAX_LENGTH;
      if (name === 'companyProfile') applicableMaxLength = COMPANY_PROFILE_MAX_LENGTH;
      else if (name === 'comment') applicableMaxLength = COMMENT_MAX_LENGTH;

      if (typeof value === 'string') {
        if (name === 'companyProfile') {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 300) {
            alert("Maximum 300 words allowed.");
            return;
          }
        } else if (name === 'comment') {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 200) {
            alert("Maximum 200 words allowed in Comments.");
            return;
          }
        } else if (value.length > applicableMaxLength) {
          alert(`Value cannot exceed ${applicableMaxLength} characters.`);
          return;
        }
      }
    }

    // Name validation
    if (['Organisationname', 'authorityName', 'contact_name'].includes(name)) {
      const isValid = /^[A-Za-z\s]*$/.test(value);
      if (!isValid && value !== '') {
        alert('Only letters and spaces are allowed.');
        return;
      }
    }

    // Phone validation
    if (name === 'authorityPhone' || name === 'contact_phone') {
      const numericValue = value.replace(/\D/g, '').slice(0, PHONE_MAX_LENGTH);
      if (numericValue.length > PHONE_MAX_LENGTH) {
        alert('Phone number must not exceed 10 digits.');
        return;
      }
      setFormData((prev) => ({
        ...prev,
        [name]: numericValue,
      }));
      clearFieldError(name);
      return;
    }

    // Quantitative fields validation
    if (index !== null) {
      if (value === '') {
        clearFieldError(name);
      } else {
        const numVal = Number(value);
        if (numVal < 0) {
          alert('Value cannot be negative.');
          return;
        } else {
          clearFieldError(name);
        }
      }
      setFormData(prev => {
        if (index !== null) {
          const existing = Array.isArray(prev[name]) ? prev[name] : [];
          const updated = [...existing];
          updated[index] = value;
          return { ...prev, [name]: updated };
        }
        return { ...prev, [name]: value };
      });
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: typeof value === 'boolean' ? value : value,
      }));
    }

    if (name === 'Organisationname' && value && currentStep === 1) setError('');
    if (name === 'mailingAddress' && value.trim() && currentStep === 1) setError('');
    if (name === 'authorityName' && value && currentStep === 2) setError('');
    if (name === 'authorityTitle' && value && currentStep === 2) setError('');
    if (name === 'authorityEmail' && value && currentStep === 2) setError('');
    if (name === 'authorityPhone' && value && currentStep === 2) setError('');
  };

  // Handle checkbox for copying applicant data
  const handleCopyApplicantToggle = (e) => {
    const checked = e.target.checked;
    const model = {
      contact_name: "",
      contact_phone: "",
      contact_email: "",
    };

    if (checked) {
      const userInfo = JSON.parse(sessionStorage.getItem('user_info') || '{}');
      if(userInfo){
        model.contact_name = userInfo.applicant_name || userInfo.name || '';
        model.contact_phone = userInfo.applicant_phone || userInfo.phone || '';
        model.contact_email = userInfo.email || userInfo.applicant_email || '';
      }
    };

    setFormData((prev) => ({...prev, ...model}))
    setCopyApplicantData(checked);
    clearFieldError("contact_name");
    clearFieldError("contact_phone");
    clearFieldError("contact_email");
  };

  // Handle attachment changes
  const handleAttachmentChange = (key, field, value, event = null) => {
    if (field === 'file' && value) {
      const file = value;
      const maxSizeInBytes = 5 * 1024 * 1024;
      const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];

      if (!allowedTypes.includes(file.type)) {
        alert('Only JPG, PNG, and PDF files are allowed for attachments.');
        if (event) event.target.value = null;
        return;
      }
      if (file.size > maxSizeInBytes) {
        alert('File size must not exceed 5 MB for attachments.');
        if (event) event.target.value = null;
        return;
      }
    }

    setFormData((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: value,
      },
    }));
    clearFieldError(key);
  };

   const viewFile =  async (serverPath) => {
    // "https://award-backend.fipi.org.in/media/
    const extractPath = serverPath.split('/').filter(
  (val) =>
    val !== "" && // remove empty strings
    val !== "http:" &&
    val !== "https:" &&
    val !== "media" &&
    !val.startsWith("award") &&
    !val.startsWith("localhost")
).join('/');
    
    downloadFile(extractPath)
  }
  // Handle approving authority signature upload
  const handleApprovingAuthorityChange = (files) => {
    const file = files[0];
    if (file) {
      const maxSizeInBytes = 5 * 1024 * 1024;
      const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];

      if (!allowedTypes.includes(file.type)) {
        alert('Only JPG, PNG, and PDF files are allowed for the signature.');
        return;
      }
      if (file.size > maxSizeInBytes) {
        alert('File size must not exceed 5 MB for the signature.');
        return;
      }
      setFormData((prev) => ({
        ...prev,
        approvingAuthoritySignature: file,
      }));
      clearFieldError('approvingAuthoritySignature');
    }
  };

  const handlePrint = () => {
    // ... your existing print logic remains unchanged
    const printContent = `
      <div style="font-family: Arial, sans-serif; padding: 20px;">
        <h1 style="text-align: center; color: #1e40af;">${awardTitle}</h1>
        <h2>Organization & Contact Details</h2>
        <p><strong>Organisation Name:</strong> ${formData.Organisationname || ''}</p>
        <p><strong>Postal Address:</strong> ${formData.mailingAddress || ''}</p>
        <p><strong>Approving Authority Name:</strong>  ${formData.authorityName  || ""}</p>
        <p><strong>Approving Authority Designation:</strong> ${formData.authorityTitle || ""}</p>
        <p><strong>Approving Authority Phone:</strong> ${formData.authorityPhone || ""}</p>
        <p><strong>Approving Authority Landline:</strong> ${formData.authorityPhone || ""}</p>

        <p><strong>Approving Authority Email:</strong> ${formData.authorityEmail || ""}</p>

        <h2>Nodal Official Contact Details:</h2>
        <p><strong>Contact Name:</strong> ${formData.contact_name || ''}</p>
        <p><strong>Contact Phone:</strong> ${formData.contact_phone || ''}</p>
        <p><strong>Contact Email:</strong> ${formData.contact_email || ''}</p>
        <p><strong>Provide a brief write up on your company’s profile:</strong> ${formData.companyProfile || ''}</p>
        <h2>Quantitative Information - Part 1</h2>
        <table style="width: 100%; border-collapse: collapse; margin-top: 16px;">
          <thead>
            <tr>
              <th style="border: 1px solid #000; padding: 8px;">S.No</th>
              <th style="border: 1px solid #000; padding: 8px;">Particulars</th>
              <th style="border: 1px solid #000; padding: 8px;">2024-25</th>
              <th style="border: 1px solid #000; padding: 8px;">2023-24</th>
            </tr>
          </thead>
          <tbody>
            ${part1.map(([num, label, key]) => `
              <tr>
                <td style="border: 1px solid #000; padding: 8px;">${num}</td>
                <td style="border: 1px solid #000; padding: 8px;">${label}</td>
                <td style="border: 1px solid #000; padding: 8px;">${formData[key][0] || ''}</td>
                <td style="border: 1px solid #000; padding: 8px;">${formData[key][1] || ''}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
        <h2>Quantitative Information - Part 2</h2>
        <table style="width: 100%; border-collapse: collapse; margin-top: 16px;">
          <thead>
            <tr>
              <th style="border: 1px solid #000; padding: 8px;">S.No</th>
              <th style="border: 1px solid #000; padding: 8px;">Particulars</th>
              <th style="border: 1px solid #000; padding: 8px;">2024-25</th>
              <th style="border: 1px solid #000; padding: 8px;">2023-24</th>
            </tr>
          </thead>
          <tbody>
            ${part2.map(([num, label, key]) => `
              <tr>
                <td style="border: 1px solid #000; padding: 8px;">${num}</td>
                <td style="border: 1px solid #000; padding: 8px;">${label}</td>
                <td style="border: 1px solid #000; padding: 8px;">${formData[key][0] || ''}</td>
                <td style="border: 1px solid #000; padding: 8px;">${formData[key][1] || ''}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
        <h2>Attachments</h2>
        <table style="width: 100%; border-collapse: collapse; margin-top: 16px;">
          <thead>
            <tr>
              <th style="border: 1px solid #000; padding: 8px;width:10px">S.No</th>
              <th style="border: 1px solid #000; padding: 8px;">Description</th>
              <th style="border: 1px solid #000; padding: 8px;">File Name</th>
            </tr>
          </thead>
          <tbody>
            ${[1, 2, 3, 4].map(i => `
              <tr>
                <td style="border: 1px solid #000; padding: 8px;">${i}</td>
                <td style="border: 1px solid #000; padding: 8px;">${formData[`attachments${i}`].description || ''}</td>
                <td style="border: 1px solid #000; padding: 8px;">${formData[`attachments${i}`].file?.name || ''}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
        <h2>Comments</h2>
        <p>${formData.comment || ''}</p>
        <h2>Declaration</h2>
        <p>I declare that the information submitted is true and complete.</p>
        <br/>
        <p><strong>Approving Authority Name:</strong> ${formData.authorityName || ""}</p>
        <p><strong>Approving Authority Designation:</strong> ${formData.authorityTitle || ""}</p>
        <p><strong>Signed on:</strong> ${formData.signatureDate || new Date().toLocaleDateString()}</p>
        <p><strong>Approving Authority Signature:</strong></p>
      </div>
    `;
    const printWindow = window.open("", "_blank", "height=600,width=800");
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="UTF-8">
          <title>${awardTitle || "Form Print"}</title>
        </head>
        <body>
          ${printContent}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  };


  // Navigation handlers
  const nextStep = () => {
    if (currentStep === 1) {
      if (!formData.Organisationname) {
        alert('Organisation name is required.');
        return;
      }
      if (!formData.mailingAddress.trim()) {
        alert('Mailing address is required.');
        return;
      }
    }
    if (currentStep === 2) {
      if (!formData.authorityName) {
        alert('Authority name is required.');
        return;
      }
      if (!formData.authorityTitle) {
        alert('Authority designation is required.');
        return;
      }
      if (!formData.authorityEmail || !validateEmail(formData.authorityEmail)) {
        alert('Please enter a valid Authority email.');
        return;
      }
      if (!formData.authorityLandline) {
        alert('Authority Landline is required.');
        return;
      }
      if (!formData.contact_name) {
        alert('Contact name is required.');
        return;
      }
      if (formData.contact_email && !validateEmail(formData.contact_email)) {
        alert('Please enter a valid Contact email.');
        return;
      }
      if (formData.contact_phone && !validatePhone(formData.contact_phone) && !copyApplicantData) {
        alert('Contact phone must be exactly 10 digits.');
        return;
      }
      if (!formData.companyProfile) {
        alert('Company Profile is required.');
        return;
      }
    }
    if (currentStep === 3 && hasEmptyFieldsInStep(currentStep)) {
      if (!window.confirm('Data not entered, If you wish to continue?')) {
        return; // Stop advancing
      }
    }

    if (currentStep === 4 && hasEmptyFieldsInStep(currentStep)) {
      if (!window.confirm('Data not entered, If you wish to continue?')) {
        return;
      }
    }

    setError('');
    if (currentStep < 5) setCurrentStep((prev) => prev + 1);
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep((prev) => prev - 1);
  };

  // Save draft handler
  const handleSaveDraft = () => {
    localStorage.setItem(
      "registrationCBGDraft",
      JSON.stringify({ formData })
    );
    handleSubmit(null);
    alert("Draft Saved!");
  };


  //Final Submit button

  const finalSubmit = () => {
    handleSubmit(null, "submited")
  }

  
  // Submit form handler
//   async function handleSubmit(event, clickType = "draft") {
//     if (event) {
//       event?.preventDefault();
//     }
//     console.log("############################ Save the DAta on Server ##########################")
//     // 1) Make a local copy of formData so we don't rely on async state updates
//     let payload = { ...formData };
	


//     // 2) Build FormData object
//     const fd = new FormData();

//     fd.append("form_id", formId);
//     fd.append("form_mode", clickType);
//     // Add Table Pk Id;
//     if (PkId > 0) fd.append("id", PkId);
//     console.log("PkId", PkId)

//     // 2a) Flat fields
//     const flatMap = {
//       organisation_name: formData.Organisationname,
//       category: formData.category,
//       company_name: formData.companyName || "",
//       mailing_address: formData.mailingAddress,

//       firstname: formData.firstname,
//       lastname: formData.lastname,

//       authority_name: formData.authorityName,
//       authority_title: formData.authorityTitle,
//       authority_phone: formData.authorityPhone,
//       authority_email: formData.authorityEmail,
//       authorityLandline: formData.authorityLandline,

//       contact_name: formData.contact_name,
//       contact_phone: formData.contact_phone,
//       contact_email: formData.contact_email,

//       company_profile: formData.companyProfile,
//       comment: formData.comment,
//       declaration: String(formData.declaration),
//     };

//     Object.entries(flatMap).forEach(([key, val]) => {
//       fd.append(key, val || "");
//     });

//     // 2b) Quantitative arrays (two values: 2024, 2023)
//     const metrics = [
//       ["retail_outlets", formData.retailOutlets2024],
//       ["install_capacity", formData.install2024],
//       ["actual_prod", formData.actual2024],
//       ["safety_index", formData.safety2024],
//       ["accident_rate", formData.accident_rate2024],
//       ["totalhourworked", formData.totalhourworked2024],
//       ["lost_injury_rate", formData.injury2024],
//       ["incident_rate", formData.incident_rate2024],
//       ["lubricants_sales", formData.lubricantsSales2024],
//       ["patents_filed", formData.patent2024],
//       ["patents_national", formData.national2024],
//       ["patents_international", formData.international2024],
//       ["patents_commercial", formData.commercial2024],
//     ];

//     metrics.forEach(([base, arr]) => {
//       const [v2024, v2023] = arr || ["", ""];
//       fd.append(`${base}_2024`, v2024 || "");
//       fd.append(`${base}_2023`, v2023 || "");
//     });

//     // 2c) File uploads
//     if (formData.approvingAuthoritySignature instanceof File) {
//       fd.append("approving_authority_file", formData.approvingAuthoritySignature);
//     }

//     [1, 2, 3, 4].forEach((n) => {
//       const { description, file } = formData[`attachments${n}`] || {};
//       fd.append(`attachments${n}_desc`, description || "");
//       if (file instanceof File) {
//         fd.append(`attachments${n}`, file);
//       }
//     });

//     // 3) Axios POST request
//     try {
//       const res = await apiClient.post("/registration-cbg/", fd, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });


//       prefillFormData();
//     }catch (err) {
//   console.error("CBG submission error:", err);

//   const respData = err?.response?.data;

//   // 1) If server returned field-level validation like { organisation_name: [...] }
//   if (respData && respData.organisation_name) {
//     // show your specific popup text
//     alert("The application is already submitted from your organization for this category.");
//     return;
//   }

//   // 2) If server returned a friendly error key e.g. { error: "..." }
//   if (respData && respData.error) {
//     alert(respData.error);
//     return;
//   }

//   // fallback
//   const serverMsg = err?.response?.data ?? err?.message ?? JSON.stringify(err);
//   alert("Submission failed: " + JSON.stringify(serverMsg));
// }
//   }
async function handleSubmit(event, clickType = "draft") {
  if (event) event.preventDefault();

  console.log("############################ Save the Data on Server ##########################");

  // make local snapshot
  const payload = { ...formData };

  // build FormData
  const fd = new FormData();
  fd.append("form_id", formId);
  fd.append("form_mode", clickType);
  if (typeof PkId !== "undefined" && PkId > 0) fd.append("id", PkId);
  console.log("PkId", PkId);

  // --- 2a) Flat fields (use ?? to preserve 0)
  const flatMap = {
    organisation_name: formData.Organisationname,
    category: formData.category,
    company_name: formData.companyName ?? "",
    mailing_address: formData.mailingAddress,
    firstname: formData.firstname,
    lastname: formData.lastname,
    authority_name: formData.authorityName,
    authority_title: formData.authorityTitle,
    authority_phone: formData.authorityPhone,
    authority_email: formData.authorityEmail,
    authorityLandline: formData.authorityLandline,
    contact_name: formData.contact_name,
    contact_phone: formData.contact_phone,
    contact_email: formData.contact_email,
    company_profile: formData.companyProfile,
    comment: formData.comment,
    declaration: String(formData.declaration),
    // add any other flat fields here...
  };

  Object.entries(flatMap).forEach(([key, val]) => {
    // Use nullish coalescing to preserve 0 and empty-string intentionally if provided
    fd.append(key, val ?? "");
  });

  // --- 2b) Quantitative arrays
  // IMPORTANT: Use explicit server field names to avoid accidental duplication.
  // Your backend shows totalhourworked2024 / totalhourworked2023 (no underscore).
  const metrics = [
    { f2024: "retail_outlets_2024", f2023: "retail_outlets_2023", values: formData.retailOutlets2024 },
    { f2024: "install_capacity_2024", f2023: "install_capacity_2023", values: formData.install2024 },
    { f2024: "actual_prod_2024", f2023: "actual_prod_2023", values: formData.actual2024 },
    { f2024: "safety_index_2024", f2023: "safety_index_2023", values: formData.safety2024 },
    { f2024: "accident_rate_2024", f2023: "accident_rate_2023", values: formData.accident_rate2024 },
    // <-- backend fields shown in your message: totalhourworked2024 and totalhourworked2023 (no underscore)
    { f2024: "totalhourworked2024", f2023: "totalhourworked2023", values: formData.totalhourworked2024 },
    { f2024: "lost_injury_rate_2024", f2023: "lost_injury_rate_2023", values: formData.injury2024 },
    { f2024: "incident_rate_2024", f2023: "incident_rate_2023", values: formData.incident_rate2024 },
    { f2024: "lubricants_sales_2024", f2023: "lubricants_sales_2023", values: formData.lubricantsSales2024 },
    { f2024: "patents_filed_2024", f2023: "patents_filed_2023", values: formData.patent2024 },
    { f2024: "patents_national_2024", f2023: "patents_national_2023", values: formData.national2024 },
    { f2024: "patents_international_2024", f2023: "patents_international_2023", values: formData.international2024 },
    { f2024: "patents_commercial_2024", f2023: "patents_commercial_2023", values: formData.commercial2024 },
  ];

  metrics.forEach(({ f2024, f2023, values }) => {
    // values expected as [value2024, value2023] or maybe a single value; handle both
    let v2024, v2023;
    if (Array.isArray(values)) {
      v2024 = values[0];
      v2023 = values[1];
    } else if (values && typeof values === "object" && "value" in values) {
      // defensive: in case some UI uses an object
      v2024 = values.value?.[0] ?? values.value;
      v2023 = values.value?.[1];
    } else {
      // treat non-array as 2024-only
      v2024 = values;
      v2023 = undefined;
    }

    // Convert numbers to string (backend DecimalField expects numeric string). Preserve 0.
    if (v2024 !== undefined && v2024 !== null && v2024 !== "") fd.append(f2024, String(v2024));
    else fd.append(f2024, ""); // append blank explicitly if missing

    if (f2023) {
      if (v2023 !== undefined && v2023 !== null && v2023 !== "") fd.append(f2023, String(v2023));
      else fd.append(f2023, "");
    }
  });

  // --- 2c) File uploads
  if (formData.approvingAuthoritySignature instanceof File) {
    fd.append("approving_authority_file", formData.approvingAuthoritySignature);
  }

  // attachments1..4: ensure we use bracket access with template strings
  [1, 2, 3, 4].forEach((n) => {
    const att = formData[`attachments${n}`] || {};
    const description = att.description ?? "";
    const file = att.file ?? null;

    fd.append(`attachments${n}_desc`, description);

    // file might be a File or FileList (if your input allows multiple)
    if (file instanceof File) {
      fd.append(`attachments${n}`, file);
    } else if (file && typeof File !== "undefined" && file instanceof FileList && file.length > 0) {
      // if FileList, append first file (or adapt as needed)
      fd.append(`attachments${n}`, file[0]);
    }
  });

  // DEBUG: log FormData keys & values (files will be File objects)
  for (const pair of fd.entries()) {
    console.log("FormData:", pair[0], pair[1]);
  }

  // --- 3) Axios POST
  try {
    // Axios can set Content-Type boundary automatically. Setting it manually is OK but
    // when you set Content-Type you must not set boundary; axios/browser handles it.
    const res = await apiClient.post("/registration-cbg/", fd, {
      headers: { "Content-Type": "multipart/form-data" }, // optional
    });

    // success handler
    prefillFormData();
    console.log("Submission successful:", res?.data);
  } catch (err) {
    console.error("CBG submission error:", err);
    const respData = err?.response?.data;

    if (respData && respData.organisation_name) {
      alert("The application is already submitted from your organization for this category.");
      return;
    }
    if (respData && respData.error) {
      alert(respData.error);
      return;
    }

    const serverMsg = err?.response?.data ?? err?.message ?? JSON.stringify(err);
    alert("Submission failed: " + JSON.stringify(serverMsg));
  }
}


  // Quantitative data for steps 3 and 4
  const part1 = [
    ['1', 'Absolute CapEx (INR - crores)', 'retailOutlets2024'],
    ['2', 'Installed Capacity (MTPA)', 'install2024'],
    ['3', 'Actual Production (MTPA)', 'actual2024'],
    ['4', 'Safety', 'safety2024'],
    ['4.1', 'Number of Fatalities', 'accident_rate2024'],
    ['4.2','Total hours worked','totalhourworked2024'],
    ['4.3', 'Lost Time Injuries', 'injury2024'],
    ['4.4', 'Total Recordable Incident Rate', 'incident_rate2024'],
  ];

  const part2 = [
    ['5', 'R&D in CBG Area', 'lubricantsSales2024'],
    ['5.1', 'Number of Patents filed', 'patent2024'],
    ['5.2', 'Number of Patents granted - National', 'national2024'],
    ['5.3', 'Number of Patents Granted – International', 'international2024'],
    ['5.4', 'Number of Patents commercialized', 'commercial2024'],
  ];

  // Rendering steps content
  
  const hasEmptyFieldsInStep = (step) => {
  const stepData = step === 3 ? part1 : part2;
 
  for (const [, , key] of stepData) {
    if (!key) continue;
 
    const val = formData[key];
    if (val === undefined || val === null || val === "") {
      return true;
    }
    if (
      Array.isArray(val) &&
      val.some((v) => v === "" || v === null || v === undefined)
    ) {
      return true;
    }
  }
 
  return false;
};
  
  const renderStepContent = () => {
    const progress = ((currentStep - 1) / 4) * 100;

    return (
      <div className="form-step" role="form" aria-label={`Step ${currentStep} of 5`}>
        <div className="progress-bar" aria-hidden="true">
          <div className="progress" style={{ width: `${progress}%` }} />
        </div>

        {currentStep === 1 && (
          <>
            <h3 className="step-title">Step 1: Organization Details</h3>

            <div className="form-group">
              <label htmlFor="Organisationname">
                Organisation Name 
                {/* <span aria-hidden="true" className="text-red">*</span> */}
              </label>
              <input
                id="Organisationname"
                name="Organisationname"
                type="text"
                maxLength={FIELD_MAX_LENGTH}
                value={formData.Organisationname}
                // onChange={(e) => handleChange('Organisationname', e.target.value)}
                disabled ={true}
                aria-describedby="Organisationname-error"
                className={`form-input ${!formData.Organisationname && currentStep === 1 ? 'has-error' : ''}`}
                placeholder="Enter organisation name"
                required
              />
              {fieldErrors.Organisationname && (
                <span className="error-tooltip" id="Organisationname-error" role="alert">
                  {fieldErrors.Organisationname}
                </span>
              )}
              {!formData.Organisationname && currentStep === 1 && (
                <span className="error-tooltip" id="Organisationname-error" role="alert">
                  Organisation name is required
                </span>
              )}
            </div>


            <div className="form-group">
              <label htmlFor="mailingAddress">
                Postal Address <span aria-hidden="true" className="text-red">*</span>
              </label>
              <textarea
                id="mailingAddress"
                name="mailingAddress"
                value={formData.mailingAddress}
                rows={3}
                maxLength={FIELD_MAX_LENGTH}
                onChange={(e) => handleChange('mailingAddress', e.target.value)}
                aria-describedby="mailingAddress-error"
                placeholder="Enter postal address"
                className={`form-textarea ${!formData.mailingAddress.trim() && currentStep === 1 ? 'has-error' : ''}`}
                required
              />
              {fieldErrors.mailingAddress && (
                <span className="error-tooltip" id="mailingAddress-error" role="alert">
                  {fieldErrors.mailingAddress}
                </span>
              )}
              {!formData.mailingAddress.trim() && currentStep === 1 && (
                <span className="error-tooltip" id="mailingAddress-error" role="alert">
                  Mailing address is required
                </span>
              )}
            </div>
          </>
        )}

        {currentStep === 2 && (
          <>
            <h3 className="step-title">Step 2: Approving Authority & Contact</h3>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <section aria-labelledby="approving-authority-heading" className="step-section">
                <h4 id="approving-authority-heading">Approving Authority</h4>
<p className="note">Approving authority should be concerned  Director /Board level executive. </p>
                <div className="form-group">
                  <label htmlFor="authorityName">
                    Name <span aria-hidden="true" className="text-red">*</span>
                  </label>
                  <input
                    id="authorityName"
                    name="authorityName"
                    type="text"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.authorityName}
                    onChange={(e) => handleChange('authorityName', e.target.value)}
                    aria-describedby="authorityName-error"
                    placeholder="Name"
                    className={`form-input ${!formData.authorityName && currentStep === 2 ? 'has-error' : ''}`}
                    required
                  />
                  {fieldErrors.authorityName && (
                    <span className="error-tooltip" id="authorityName-error" role="alert">
                      {fieldErrors.authorityName}
                    </span>
                  )}
                  {!formData.authorityName && currentStep === 2 && (
                    <span className="error-tooltip" id="authorityName-error" role="alert">
                      Name is required
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="authorityTitle">
                    Designation <span aria-hidden="true" className="text-red">*</span>
                  </label>
                  <input
                    id="authorityTitle"
                    name="authorityTitle"
                    type="text"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.authorityTitle}
                    onChange={(e) => handleChange('authorityTitle', e.target.value)}
                    aria-describedby="authorityTitle-error"
                    placeholder="Designation"
                    className={`form-input ${!formData.authorityTitle && currentStep === 2 ? 'has-error' : ''}`}
                    required
                  />
                  {fieldErrors.authorityTitle && (
                    <span className="error-tooltip" id="authorityTitle-error" role="alert">
                      {fieldErrors.authorityTitle}
                    </span>
                  )}
                  {!formData.authorityTitle && currentStep === 2 && (
                    <span className="error-tooltip" id="authorityTitle-error" role="alert">
                      Designation is required
                    </span>
                  )}
                </div>
  <div className="form-group">
                                    <label htmlFor="authorityPhone">
                                        Landline: <span className="text-red" aria-hidden="true">*</span>
                                    </label>
                                    <input
                                        id="authorityLandline"
                                        type="number"
                                        name="authorityLandline"
                                        value={formData.authorityLandline}
                                        onChange={(e) => handleChange('authorityLandline', e.target.value)}
                                        // onBlur={(e) => handleBlur('authorityLandline', e.target.value)}
                                        className={`form-input ${!formData.authorityLandline && currentStep === 2 ? 'has-error' : ''}`}
                                        placeholder="Landline number"
                                        aria-required="true"
                                        aria-describedby={fieldErrors.authorityLandline ? 'authorityLandline-error' : undefined}
                                    />
                                    {!formData.authorityLandline && currentStep === 2 && <span className="error-tooltip">Authority Landline Number is required</span>}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="authorityPhone">
                                        Mobile: 
                                        {/* <span className="text-red" aria-hidden="true">*</span> */}
                                    </label>
                                    <input
                                        id="authorityPhone"
                                        type="tel"
                                        name="authorityPhone"
                                        value={formData.authorityPhone}
                                        onChange={(e) => handleChange('authorityPhone', e.target.value)}
                                        // onBlur={(e) => handleBlur('authorityPhone', e.target.value)}
                                        className={`form-input`}
                                        placeholder="Phone number"
                                        maxLength={PHONE_MAX_LENGTH}
                                        aria-required="true"
                                    // aria-describedby={fieldErrors.authorityPhone ? 'authorityPhone-error' : undefined}
                                    />
                                </div>


                <div className="form-group">
                  <label htmlFor="authorityEmail">
                    Email <span aria-hidden="true" className="text-red">*</span>
                  </label>
                  <input
                    id="authorityEmail"
                    name="authorityEmail"
                    type="email"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.authorityEmail}
                    onChange={(e) => handleChange('authorityEmail', e.target.value)}
                    aria-describedby="authorityEmail-error"
                    placeholder="Approving authority's email"
                    className={`form-input ${!formData.authorityEmail && currentStep === 2 ? 'has-error' : ''}`}
                    required
                  />
                  {fieldErrors.authorityEmail && (
                    <span className="error-tooltip" id="authorityEmail-error" role="alert">
                      {fieldErrors.authorityEmail}
                    </span>
                  )}
                  {!formData.authorityEmail && currentStep === 2 && (
                    <span className="error-tooltip" id="authorityEmail-error" role="alert">
                      Email is required
                    </span>
                  )}
                </div>
              </section>

              <section aria-labelledby="contacts-heading" className="step-section">
                <h4 id="contacts-heading">Contacts (Nodal Officials) <span aria-hidden="true" className="text-red">*</span></h4>

                <div className="form-group">
                  <label>
                    <input
                      type="checkbox"
                      name="copyApplicantData"
                      // checked={copyApplicantData}
                      onChange={handleCopyApplicantToggle}
                      className="form-checkbox"
                    />{" "}
                    Same as applicant
                  </label>
                </div>

                <div className="form-group">
                  <label htmlFor="contact_name">
                    Name <span aria-hidden="true" className="text-red">*</span>
                  </label>
                  <input
                    id="contact_name"
                    name="contact_name"
                    type="text"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.contact_name}
                    onChange={(e) => handleChange("contact_name", e.target.value)}
                    placeholder="Contact name"
                    disabled={copyApplicantData}
                    className={`form-input ${!formData.contact_name && currentStep === 2 ? "has-error" : ""}`}
                    aria-describedby="contact_name-error"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="contact_phone">
                    Phone:<span aria-hidden="true" className="text-red">*</span>
                  </label>
                  <input
                    id="contact_phone"
                    name="contact_phone"
                    type="tel"
                    maxLength={PHONE_MAX_LENGTH}
                    value={formData.contact_phone}
                    onChange={(e) => handleChange("contact_phone", e.target.value)}
                    aria-describedby="contact_phone-error"
                    disabled={copyApplicantData}
                    placeholder="10-digit phone number"
                    className={`form-input ${!formData.contact_phone && currentStep === 2 ? "has-error" : ""}`}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="contact_email">Email</label>
                  <input
                    id="contact_email"
                    name="contact_email"
                    type="email"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.contact_email}
                    onChange={(e) => handleChange("contact_email", e.target.value)}
                    placeholder="Contact email"
                    disabled={copyApplicantData}
                    className={`form-input ${fieldErrors.contact_email ? "has-error" : ""}`}
                    aria-describedby="contact_email-error"
                  />
                </div>
              </section>
            </div>

            <div className="form-group">
              <label htmlFor="companyProfile">Provide a brief write up on your company’s profile.  </label>
              <p className="note">(within 300 words) </p>
              <textarea
                id="companyProfile"
                name="companyProfile"
                value={formData.companyProfile}
                rows={6}
                // maxLength={COMPANY_PROFILE_MAX_LENGTH}
                onChange={(e) => handleChange('companyProfile', e.target.value)}
                className="form-textarea"
                placeholder="Enter company profile"
              />
              {fieldErrors.companyProfile && (
                <span className="error-tooltip" id="companyProfile-error" role="alert">
                  {fieldErrors.companyProfile}
                </span>
              )}
            </div>
          </>
        )}

        {/* {currentStep === 3 && (
          <>
            <h3 className="step-title">Step 3: Quantitative Information Part 1</h3>
            <div className="quantitative-form">
              <table className="quant-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Particulars</th>
                    <th>2024-25</th>
                    <th>2023-24</th>
                  </tr>
                </thead>
                <tbody>
                  {part1.map(([num, label, key]) => (
                    <tr key={key || num}>
                      <td>{num}</td>
                      <td>{label}</td>
                      <td>
                        <TextField
  variant="outlined"
  size="small"
  fullWidth
  type="text" // prevents browser spinners
  name={key}
  value={formData[key]?.[0] || ""}
  onChange={(e) => {
    let val = e.target.value;

    // Allow only digits and a single decimal point
    val = val.replace(/[^0-9.]/g, "");
    const parts = val.split(".");
    if (parts.length > 2) {
      val = parts[0] + "." + parts.slice(1).join("");
    }

    handleChange(e.target.name, val, 0);
  }}
  onKeyDown={(e) => {
    // block '-', '+', 'e', 'E', arrow keys
    if (["-", "+", "e", "E"].includes(e.key) || e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  }}
  onWheel={(e) => e.target.blur()} // disable mouse scroll increment
  className="form-input"
  inputProps={{
    inputMode: "decimal", // numeric keypad for mobile
    pattern: "[0-9]*\\.?[0-9]*", // digits + optional decimal
    min: 0,
  }}
/>


                      </td>
                      <td>
 <TextField
  variant="outlined"
  size="small"
  fullWidth
  type="text" // prevents browser spinners
  name={key}
  value={formData[key]?.[1] || ""}
  onChange={(e) => {
    let val = e.target.value;

    // Allow only digits and a single decimal point
    val = val.replace(/[^0-9.]/g, "");
    const parts = val.split(".");
    if (parts.length > 2) {
      val = parts[0] + "." + parts.slice(1).join("");
    }

    handleChange(e.target.name, val, 1);
  }}
  onKeyDown={(e) => {
    // block '-', '+', 'e', 'E', arrow keys
    if (["-", "+", "e", "E"].includes(e.key) || e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  }}
  onWheel={(e) => e.target.blur()} // disable mouse scroll increment
  className="form-input"
  inputProps={{
    inputMode: "decimal", // numeric keypad for mobile
    pattern: "[0-9]*\\.?[0-9]*", // digits + optional decimal
    min: 0,
  }}
/>

                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )} */}
{currentStep === 3 && (
  <>
    <h3 className="step-title">Step 3: Quantitative Information Part 1</h3>
    <div className="quantitative-form">
      <table className="quant-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Particulars</th>
            <th>2024-25</th>
            <th>2023-24</th>
          </tr>
        </thead>
        <tbody>
          {part1.map(([num, label, key], index) => {
            if (headerNums.includes(num.toString())) {
              return (
                <tr key={`header-${num}-${index}`} >
                  <td className="sno-cell">{num}</td>
                  <td className="label-cell" colSpan={3}>
                    {label}
                  </td>
                </tr>
              );
            }
 
            return (
              <tr key={key || num}>
                <td>{num}</td>
                <td>{label}</td>
                <td>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    type="text"
                    name={key}
                    value={formData[key]?.[0] || ""}
                    onChange={(e) => {
                      let val = e.target.value.replace(/[^0-9.]/g, "");
                      const parts = val.split(".");
                      if (parts.length > 2) {
                        val = parts[0] + "." + parts.slice(1).join("");
                      }
                      handleChange(e.target.name, val, 0);
                    }}
                    onKeyDown={(e) => {
                      if (["-", "+", "e", "E"].includes(e.key) || e.key === "ArrowUp" || e.key === "ArrowDown") {
                        e.preventDefault();
                      }
                    }}
                    onWheel={(e) => e.target.blur()}
                    className="form-input"
                    inputProps={{
                      inputMode: "decimal",
                      pattern: "[0-9]\\.?[0-9]",
                      min: 0,
                    }}
                  />
                </td>
                <td>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    type="text"
                    name={key}
                    value={formData[key]?.[1] || ""}
                    onChange={(e) => {
                      let val = e.target.value.replace(/[^0-9.]/g, "");
                      const parts = val.split(".");
                      if (parts.length > 2) {
                        val = parts[0] + "." + parts.slice(1).join("");
                      }
                      handleChange(e.target.name, val, 1);
                    }}
                    onKeyDown={(e) => {
                      if (["-", "+", "e", "E"].includes(e.key) || e.key === "ArrowUp" || e.key === "ArrowDown") {
                        e.preventDefault();
                      }
                    }}
                    onWheel={(e) => e.target.blur()}
                    className="form-input"
                    inputProps={{
                      inputMode: "decimal",
                      pattern: "[0-9]\\.?[0-9]",
                      min: 0,
                    }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </>
)}

        {/* {currentStep === 4 && (
          <>
            <h3 className="step-title">Step 4: Quantitative Information Part 2</h3>
            <div className="quantitative-form">
              <table className="quant-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Particulars</th>
                    <th>2024-25</th>
                    <th>2023-24</th>
                  </tr>
                </thead>
                <tbody>
                  {part2.map(([num, label, key]) => (
                    <tr key={key || num}>
                      <td>{num}</td>
                      <td>{label}</td>
                      <td>
                         <TextField
  variant="outlined"
  size="small"
  fullWidth
  type="text" // prevents browser spinners
  name={key}
  value={formData[key]?.[0] || ""}
  onChange={(e) => {
    let val = e.target.value;

    // Allow only digits and a single decimal point
    val = val.replace(/[^0-9.]/g, "");
    const parts = val.split(".");
    if (parts.length > 2) {
      val = parts[0] + "." + parts.slice(1).join("");
    }

    handleChange(e.target.name, val, 0);
  }}
  onKeyDown={(e) => {
    // block '-', '+', 'e', 'E', arrow keys
    if (["-", "+", "e", "E"].includes(e.key) || e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  }}
  onWheel={(e) => e.target.blur()} // disable mouse scroll increment
  className="form-input"
  inputProps={{
    inputMode: "decimal", // numeric keypad for mobile
    pattern: "[0-9]*\\.?[0-9]*", // digits + optional decimal
    min: 0,
  }}
/>

                      </td>
                      <td>
                        <TextField
  variant="outlined"
  size="small"
  fullWidth
  type="text" // prevents browser spinners
  name={key}
  value={formData[key]?.[1] || ""}
  onChange={(e) => {
    let val = e.target.value;

    // Allow only digits and a single decimal point
    val = val.replace(/[^0-9.]/g, "");
    const parts = val.split(".");
    if (parts.length > 2) {
      val = parts[0] + "." + parts.slice(1).join("");
    }

    handleChange(e.target.name, val, 1);
  }}
  onKeyDown={(e) => {
    // block '-', '+', 'e', 'E', arrow keys
    if (["-", "+", "e", "E"].includes(e.key) || e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  }}
  onWheel={(e) => e.target.blur()} // disable mouse scroll increment
  className="form-input"
  inputProps={{
    inputMode: "decimal", // numeric keypad for mobile
    pattern: "[0-9]*\\.?[0-9]*", // digits + optional decimal
    min: 0,
  }}
/>

                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="form-group">
                <label htmlFor="comment">Comments</label>
                <textarea
                  id="comment"
                  name="comment"
                  // maxLength={COMMENT_MAX_LENGTH}
                  value={formData.comment}
                  onChange={(e) => handleChange('comment', e.target.value)}
                  className="form-textarea"
                  placeholder="Comments in (200 words) against input parameter, if any"
                  rows={4}
                />
                {fieldErrors.comment && (
                  <span className="error-tooltip" id="comment-error" role="alert">
                    {fieldErrors.comment}
                  </span>
                )}
              </div>
            </div>
          </>
        )} */}

        {currentStep === 4 && (
  <>
    <h3 className="step-title">Step 4: Quantitative Information Part 2</h3>
    <div className="quantitative-form">
      <table className="quant-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Particulars</th>
            <th>2024-25</th>
            <th>2023-24</th>
          </tr>
        </thead>
        <tbody>
          {part2.map(([num, label, key], index) => {
            if (headerNums.includes(num.toString())) {
              return (
                <tr
                  key={`header-${num}-${index}`}
                 
                >
                  <td className="sno-cell">{num}</td>
                  <td className="label-cell" colSpan={3}>
                    {label}
                  </td>
                </tr>
              );
            }
 
            return (
              <tr key={key || num}>
                <td>{num}</td>
                <td>{label}</td>
                <td>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    type="text"
                    name={key}
                    value={formData[key]?.[0] || ""}
                    onChange={(e) => {
                      let val = e.target.value.replace(/[^0-9.]/g, "");
                      const parts = val.split(".");
                      if (parts.length > 2) {
                        val = parts[0] + "." + parts.slice(1).join("");
                      }
                      handleChange(e.target.name, val, 0);
                    }}
                    onKeyDown={(e) => {
                      if (
                        ["-", "+", "e", "E"].includes(e.key) ||
                        e.key === "ArrowUp" ||
                        e.key === "ArrowDown"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    onWheel={(e) => e.target.blur()}
                    className="form-input"
                    inputProps={{
                      inputMode: "decimal",
                      pattern: "[0-9]\\.?[0-9]",
                      min: 0,
                    }}
                  />
                </td>
                <td>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    type="text"
                    name={key}
                    value={formData[key]?.[1] || ""}
                    onChange={(e) => {
                      let val = e.target.value.replace(/[^0-9.]/g, "");
                      const parts = val.split(".");
                      if (parts.length > 2) {
                        val = parts[0] + "." + parts.slice(1).join("");
                      }
                      handleChange(e.target.name, val, 1);
                    }}
                    onKeyDown={(e) => {
                      if (
                        ["-", "+", "e", "E"].includes(e.key) ||
                        e.key === "ArrowUp" ||
                        e.key === "ArrowDown"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    onWheel={(e) => e.target.blur()}
                    className="form-input"
                    inputProps={{
                      inputMode: "decimal",
                      pattern: "[0-9]\\.?[0-9]",
                      min: 0,
                    }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
 
      <div className="form-group">
        <label htmlFor="comment">Comments</label>
        <textarea
          id="comment"
          name="comment"
          value={formData.comment}
          onChange={(e) => handleChange("comment", e.target.value)}
          className="form-textarea"
          placeholder="Comments in (200 words) against input parameter, if any"
          rows={4}
        />
        {fieldErrors.comment && (
          <span className="error-tooltip" id="comment-error" role="alert">
            {fieldErrors.comment}
          </span>
        )}
      </div>
    </div>
  </>
)}



        {currentStep === 5 && (
          <>
            <h3 className="step-title">Step 5: Attachments & Declaration</h3>

            <div className="form-group">
              <label>List of Attachments (Optional):</label>
              <table className="quant-table">
                <thead>
                  <tr>
                    <th>S. No.</th>
                    <th>Description</th>
                    <th>Upload (jpg, png, pdf; max 5 MB)</th>
                  </tr>
                </thead>
                {/* <tbody>
                  {[1, 2, 3, 4].map((num) => {
                    const key = `attachments${num}`;
                    const attachment = formData[key];
                    return (
                      <tr key={key}>
                        <td>{num}</td>
                        <td>
                          <input
                            type="text"
                            name={`${key}.description`}
                            value={attachment.description}
                            onChange={(e) => handleAttachmentChange(key, 'description', e.target.value)}
                            placeholder="Enter description"
                            maxLength={FIELD_MAX_LENGTH}
                            className="form-input"
                          />
                        </td>
                        <td>
                          <input
                            type="file"
                            accept=".jpg,.png,.pdf"
                            onChange={(e) => handleAttachmentChange(key, 'file', e.target.files[0], e)}
                            className="form-input mt-4"
                          />
                          {attachment.file && (
                            <p className="file-name">Selected file: {attachment.file.name}</p>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody> */}
                <tbody>
                  {[1, 2, 3, 4].map((num) => {
                    const key = `attachments${num}`;
                    const attachment = formData[key] || { description: "", file: null };
                    return (
                      <tr key={key}>
                        <td>{num}</td>
                        <td>
                          <input type="text" name={`${key}.description`} value={attachment.description} onChange={(e) => handleAttachmentChange(key, "description", e.target.value)} placeholder="Enter description" maxLength={FIELD_MAX_LENGTH} className="form-input" />
                        </td>
                        <td>
                          <input type="file" accept=".jpg,.png,.pdf" onChange={(e) => handleAttachmentChange(key, "file", e.target.files[0], e)} className="form-input mt-4" />
                          {attachment.file && <p className="file-name">Selected file: {attachment.file.name}</p>}
                          {attachment.url && !attachment.file && (
  <p className="file-name">
    Uploaded file:{" "}
    <button
      type="button"
      onClick={() => viewFile(attachment.url)}
      style={{ background: "none", border: "none", padding: 0, color: "#06c", cursor: "pointer", textDecoration: "underline" }}
    >
      View
    </button>
  </p>
)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="form-group">
              <label>
                Print the completed application form and upload it with the signature of the approving authority. Without signature of the approving authority, application will not be considered valid.<span aria-hidden="true" className="text-red">*</span>
              </label>
              <div className="form-navigation">
                <button type="button" onClick={handlePrint} className="btn btn-outline">
                  <Save size={16} /> Print Preview
                </button>
              </div>
            </div>

            <div className="form-group">
                            <label htmlFor="approvingAuthoritySignature">
                                Upload Document with Approving Authority Signature (Director/Board Level)
                                <span aria-hidden="true" className="text-red">*</span>:
                            </label>
                            <input
                                type="file"
                                id="approvingAuthoritySignature"
                                accept=".jpg,.png,.pdf"
                                onChange={(e) => {
                                    const files = e.target.files;
                                    if (files.length > 0) {
                                        const confirmed = window.confirm(
                                            "Are you sure the form is approved and signed by approving authority?"
                                        );
                                        if (!confirmed) {
                                            // If user clicks "Cancel", clear the input
                                            e.target.value = "";
                                            return;
                                        }
                                        handleApprovingAuthorityChange(files);
                                    }
                                }}
                                className={`form-input mt-4 ${fieldErrors.approvingAuthoritySignature ? "has-error" : ""}`}
                                aria-describedby="approvingAuthoritySignature-error"
                                required
                            />
                            {formData.approvingAuthoritySignature && (
                                <p className="file-name">
                                    Selected file: {formData.approvingAuthoritySignature.name}
                                </p>
                            )}
                             {formData.approvingAuthoritySignatureUrl && !formData.approvingAuthoritySignature && (
    <p className="file-name">
      Uploaded file:{" "}
      <button
        type="button"
        onClick={() => viewFile(formData.approvingAuthoritySignatureUrl)}
        style={{ background: "none", border: "none", padding: 0, color: "#06c", cursor: "pointer", textDecoration: "underline" }}
      >
        View
      </button>
    </p>
  )}
                            {fieldErrors.approvingAuthoritySignature && (
                                <span className="error-tooltip" id="approvingAuthoritySignature-error" role="alert">
                                    {fieldErrors.approvingAuthoritySignature}
                                </span>
                            )}
                        </div>

            <div className="form-group">
              <label>
                <input
                  id="declaration"
                  type="checkbox"
                  name="declaration"
                  checked={formData.declaration}
                  onChange={(e) => handleChange('declaration', e.target.checked)}
                  className={`form-checkbox ${fieldErrors.declaration ? 'has-error' : ''}`}
                  aria-describedby="declaration-error"
                  required
                />{' '}
                I declare that the information submitted is true and complete.
              </label>
              {fieldErrors.declaration && (
                <span className="error-tooltip" id="declaration-error" role="alert">
                  {fieldErrors.declaration}
                </span>
              )}

            </div>
          </>
        )}
      </div>
    );
  };
  useEffect(() => {
    const middlePosition = window.innerHeight / 2; // middle
    window.scrollTo({ top: middlePosition + 100, behavior: 'smooth' });
  }, [currentStep]);

  return (
    <div className="sidebar-guideline-container">
            <SidebarGuideline
                isOpen={true}
                sidebarItems={[{ id: 'Guideline', label: 'Guideline' }]}
                activeItem={activeItem}
                setActiveItem={setActiveItem}
                selectedAwardCategory={formData.category}
            />
    <div className="application-form">
      <div className="form-header">
        <h1>
           {awardTitle}
        </h1>
        <h6>Step {currentStep} of 5</h6>
      </div>
      {error && <div className="error">{error}</div>}
      {isSubmitted ? (
        <div className="thank-you-message">
            <h2>Thank you for your submission!</h2>
            <p>Your Application has been successfully submitted.</p>
           <button onClick={() => navigate('/#Award%20Categories')}>
  Submit Another Application
</button>
          </div>
      ) : (
        <form onSubmit={handleSubmit}>
          {renderStepContent()}
          {currentStep === 1 && (
            <div className="form-navigation-step1">
              <button
                  type="button"
                  onClick={handleSaveDraft}
                  className="btn btn-outline"
                  disabled={isSubmited()}
                >
                  <Save size={16} /> Save Draft
                </button>
              <button type="button" onClick={nextStep} className="btn btn-primary">
                Next <ChevronRight size={16} />
              </button>
            </div>
          )}
          {currentStep > 1 && (
            <div className="form-navigation">
              <button type="button" onClick={prevStep} className="btn btn-outline">
                <ChevronLeft size={16} /> Previous
              </button>
              <button
                  type="button"
                  onClick={handleSaveDraft}
                  className="btn btn-outline"
                  disabled={isSubmited()}
                >
                  <Save size={16} /> Save Draft
                </button>
              {currentStep < 5 && (
                <button type="button" onClick={nextStep} className="btn btn-primary">
                  Next <ChevronRight size={16} />
                </button>
              )}
              {currentStep === 5 && (
                <button
                    type="button"
                    className="btn btn-success"
                    disabled={isSubmited()}
                    onClick={(e) => {
                      if (!formData.declaration) {
                        return alert("Please accept the declaration before submitting.");
                      }
                      if (!formData.approvingAuthoritySignature) {
                        return alert("Please upload the approving authority signature file.");
                      }
                      if (!window.confirm("Are you sure you want to submit?")) {
                        e.preventDefault();

                      }
                      alert("CBG registration submitted successfully!");
                      setIsSubmitted(true);
      


                      handleSubmit(e, "submit");
                    }}
                  >
                    Submit
                  </button>
              )}
            </div>
          )}
        </form>
      )}
    </div>
    </div>
  );
};

export default RegistrationCBG;
